"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCheckoutPayloadFromShortenerId = exports.getShortenedCheckoutUrl = exports.prepareFullCheckoutPayload = void 0;
var tslib_1 = require("tslib");
var BaseApi_1 = tslib_1.__importDefault(require("../../API/BaseApi"));
var index_1 = require("../../Config/index");
var constants_1 = require("../authorize/constants");
var interfaces_1 = require("../common/interfaces");
var interfaces_2 = require("../pricingApi/interfaces");
var constants_2 = require("./constants");
var interfaces_3 = require("./interfaces");
var base_64_1 = tslib_1.__importDefault(require("base-64"));
function getCheckoutUrl(_a, requestOptions) {
    var _b = _a.urlType, urlType = _b === void 0 ? interfaces_3.UrlType.BASE_64_ENCODED : _b, rest = tslib_1.__rest(_a, ["urlType"]);
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var fullCheckoutPayload;
        return tslib_1.__generator(this, function (_c) {
            fullCheckoutPayload = prepareFullCheckoutPayload(rest);
            if (urlType === interfaces_3.UrlType.SHORTENED) {
                return [2 /*return*/, getShortenedCheckoutUrl(fullCheckoutPayload, requestOptions)];
            }
            return [2 /*return*/, getBase64CheckoutUrl(fullCheckoutPayload)];
        });
    });
}
function prepareFullCheckoutPayload(data) {
    var hostAnnotations = data.hostAnnotations, items = data.items;
    var mappedItems = items.map(function (item) { return (tslib_1.__assign({ catalogItemSource: constants_2.CATALOG_ITEM_SOURCE, quantity: constants_2.ITEM_QUANTITY }, item)); });
    var defaultedAnnotations = tslib_1.__assign({ isInApp: false, orderPlacedOn: "Web" }, hostAnnotations);
    return tslib_1.__assign(tslib_1.__assign({}, data), { items: mappedItems, hostAnnotations: defaultedAnnotations });
}
exports.prepareFullCheckoutPayload = prepareFullCheckoutPayload;
function getBase64CheckoutUrl(data) {
    var productType = data.productType, bundle = data.bundle, rest = tslib_1.__rest(data, ["productType", "bundle"]);
    var url = "".concat(index_1.dcoUrl, "?productType=").concat(productType) +
        "&checkoutFlowType=".concat(constants_2.CHECKOUT_FLOW_TYPE) +
        "&data=".concat(base_64_1.default.encode(JSON.stringify(rest))) +
        "&version=1";
    if (bundle)
        url += "&bundle=".concat(bundle);
    return Promise.resolve({
        success: true,
        data: {
            url: url
        },
        errors: null
    });
}
function getShortenedCheckoutUrl(data, requestOptions) {
    if (requestOptions === void 0) { requestOptions = {
        timeout: interfaces_2.PRICING_TIMEOUT
    }; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var productType, bundle, rest, request, response;
        return tslib_1.__generator(this, function (_a) {
            productType = data.productType, bundle = data.bundle, rest = tslib_1.__rest(data, ["productType", "bundle"]);
            request = {
                payload: JSON.stringify(rest),
                dataRequested: "getShortenerPayloadId"
            };
            response = BaseApi_1.default.doPostRequestToChegg(index_1.commerceDataAggregatorUrl, request, null, requestOptions.timeout);
            return [2 /*return*/, decoratePromise(response, { productType: productType, bundle: bundle })];
        });
    });
}
exports.getShortenedCheckoutUrl = getShortenedCheckoutUrl;
function getCheckoutPayloadFromShortenerId(data, requestOptions) {
    if (requestOptions === void 0) { requestOptions = {
        timeout: interfaces_2.PRICING_TIMEOUT
    }; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var request, response;
        return tslib_1.__generator(this, function (_a) {
            request = {
                payloadId: data.id,
                dataRequested: "getShortenerPayload"
            };
            response = BaseApi_1.default.doPostRequestToChegg(index_1.commerceDataAggregatorUrl, request, null, requestOptions.timeout);
            return [2 /*return*/, decoratePromise(response)];
        });
    });
}
exports.getCheckoutPayloadFromShortenerId = getCheckoutPayloadFromShortenerId;
function decoratePromise(promise, extra) {
    return promise
        .then(function (resp) {
        var shortener = resp.data.shortener;
        var data = shortener.data, message = shortener.message, error = shortener.error;
        if (!error && !message && data) {
            return {
                success: true,
                data: getShortenerData(tslib_1.__assign(tslib_1.__assign({}, data), (extra && tslib_1.__assign({}, extra)))),
                errors: null
            };
        }
        else {
            return {
                success: false,
                data: null,
                errors: [
                    {
                        message: message,
                        code: error,
                        type: interfaces_1.ErrorType.SERVER
                    }
                ]
            };
        }
    })
        .catch(function (error) {
        var apiError;
        if (constants_1.AuthorizeErrors[error.message] !== undefined) {
            apiError = constants_1.AuthorizeErrors[error.message];
        }
        else {
            apiError = constants_1.AuthorizeErrors.UNKNOWN_FAILURE;
        }
        return {
            errors: [apiError],
            data: null
        };
    });
}
function getShortenerData(data) {
    if ("id" in data) {
        var _a = data, id = _a.id, productType = _a.productType, bundle = _a.bundle;
        var url = "".concat(index_1.dcoUrl, "?productType=").concat(productType, "&checkoutFlowType=").concat(constants_2.CHECKOUT_FLOW_TYPE, "&id=").concat(id, "&version=2");
        if (bundle)
            url += "&bundle=".concat(bundle);
        return {
            url: url
        };
    }
    else {
        return {
            payload: data.payload
        };
    }
}
var checkoutUrlBuilderApi = {
    getCheckoutUrl: getCheckoutUrl,
    getCheckoutPayloadFromShortenerId: getCheckoutPayloadFromShortenerId
};
exports.default = checkoutUrlBuilderApi;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/modules/checkoutUrlBuilderApi/index.js
// module id = 1339
// module chunks = 11